import { Component } from '@angular/core';
import { LoadingService } from '../../services/loading/loading.service';


@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.less'],
    standalone: false
})
export class SpinnerComponent {

  protected loader$ = this.srvLoading.loader$;

  constructor(private srvLoading : LoadingService) {}
}
